"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ApiClient", {
  enumerable: true,
  get: function get() {
    return _ApiClient["default"];
  }
});
Object.defineProperty(exports, "AuthCreateTokensResponse", {
  enumerable: true,
  get: function get() {
    return _AuthCreateTokensResponse["default"];
  }
});
Object.defineProperty(exports, "AuthDeleteTokensResponse", {
  enumerable: true,
  get: function get() {
    return _AuthDeleteTokensResponse["default"];
  }
});
Object.defineProperty(exports, "AuthGetTokensResponse", {
  enumerable: true,
  get: function get() {
    return _AuthGetTokensResponse["default"];
  }
});
Object.defineProperty(exports, "AuthorizationApi", {
  enumerable: true,
  get: function get() {
    return _AuthorizationApi["default"];
  }
});
Object.defineProperty(exports, "DataExtractionApi", {
  enumerable: true,
  get: function get() {
    return _DataExtractionApi["default"];
  }
});
Object.defineProperty(exports, "DocumentVerificationResponse", {
  enumerable: true,
  get: function get() {
    return _DocumentVerificationResponse["default"];
  }
});
Object.defineProperty(exports, "DocumentVerificationResult", {
  enumerable: true,
  get: function get() {
    return _DocumentVerificationResult["default"];
  }
});
Object.defineProperty(exports, "EncodeErrorResponse", {
  enumerable: true,
  get: function get() {
    return _EncodeErrorResponse["default"];
  }
});
Object.defineProperty(exports, "EntitiesDOFontAnalysis", {
  enumerable: true,
  get: function get() {
    return _EntitiesDOFontAnalysis["default"];
  }
});
Object.defineProperty(exports, "EntitiesDoVerDocumentData", {
  enumerable: true,
  get: function get() {
    return _EntitiesDoVerDocumentData["default"];
  }
});
Object.defineProperty(exports, "EntitiesDoVerKeywordsPred", {
  enumerable: true,
  get: function get() {
    return _EntitiesDoVerKeywordsPred["default"];
  }
});
Object.defineProperty(exports, "EntitiesDoVerOCRPred", {
  enumerable: true,
  get: function get() {
    return _EntitiesDoVerOCRPred["default"];
  }
});
Object.defineProperty(exports, "EntitiesDocumentCheckResult", {
  enumerable: true,
  get: function get() {
    return _EntitiesDocumentCheckResult["default"];
  }
});
Object.defineProperty(exports, "EntitiesDocumentCheckTask", {
  enumerable: true,
  get: function get() {
    return _EntitiesDocumentCheckTask["default"];
  }
});
Object.defineProperty(exports, "EntitiesFaceManipulationResult", {
  enumerable: true,
  get: function get() {
    return _EntitiesFaceManipulationResult["default"];
  }
});
Object.defineProperty(exports, "EntitiesFaceManipulationTask", {
  enumerable: true,
  get: function get() {
    return _EntitiesFaceManipulationTask["default"];
  }
});
Object.defineProperty(exports, "EntitiesFaceRecognitionResult", {
  enumerable: true,
  get: function get() {
    return _EntitiesFaceRecognitionResult["default"];
  }
});
Object.defineProperty(exports, "EntitiesFaceRecognitionTask", {
  enumerable: true,
  get: function get() {
    return _EntitiesFaceRecognitionTask["default"];
  }
});
Object.defineProperty(exports, "EntitiesGANResult", {
  enumerable: true,
  get: function get() {
    return _EntitiesGANResult["default"];
  }
});
Object.defineProperty(exports, "EntitiesGANTask", {
  enumerable: true,
  get: function get() {
    return _EntitiesGANTask["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDetectionResult", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDetectionResult["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDetectionTask", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDetectionTask["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDoAuthenticityCheck", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDoAuthenticityCheck["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDoDocument", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDoDocument["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDoDocumentDetails", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDoDocumentDetails["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDoDocumentPosition", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDoDocumentPosition["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDoFaceDetection", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDoFaceDetection["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDoImageQualityCheck", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDoImageQualityCheck["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDoReaderBBox", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDoReaderBBox["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDoReaderImage", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDoReaderImage["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDoReaderStatus", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDoReaderStatus["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDoReaderStatusDetails", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDoReaderStatusDetails["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDoReaderText", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDoReaderText["default"];
  }
});
Object.defineProperty(exports, "EntitiesIDDoReaderTextExtracted", {
  enumerable: true,
  get: function get() {
    return _EntitiesIDDoReaderTextExtracted["default"];
  }
});
Object.defineProperty(exports, "EntitiesLivenessDetectionResult", {
  enumerable: true,
  get: function get() {
    return _EntitiesLivenessDetectionResult["default"];
  }
});
Object.defineProperty(exports, "EntitiesLivenessDetectionTask", {
  enumerable: true,
  get: function get() {
    return _EntitiesLivenessDetectionTask["default"];
  }
});
Object.defineProperty(exports, "EntitiesPoint", {
  enumerable: true,
  get: function get() {
    return _EntitiesPoint["default"];
  }
});
Object.defineProperty(exports, "EntitiesTokenClaims", {
  enumerable: true,
  get: function get() {
    return _EntitiesTokenClaims["default"];
  }
});
Object.defineProperty(exports, "FaceManipulationApi", {
  enumerable: true,
  get: function get() {
    return _FaceManipulationApi["default"];
  }
});
Object.defineProperty(exports, "FaceMatchingApi", {
  enumerable: true,
  get: function get() {
    return _FaceMatchingApi["default"];
  }
});
Object.defineProperty(exports, "ForensicAnalysisApi", {
  enumerable: true,
  get: function get() {
    return _ForensicAnalysisApi["default"];
  }
});
Object.defineProperty(exports, "GANDetectionApi", {
  enumerable: true,
  get: function get() {
    return _GANDetectionApi["default"];
  }
});
Object.defineProperty(exports, "IDDetectionApi", {
  enumerable: true,
  get: function get() {
    return _IDDetectionApi["default"];
  }
});
Object.defineProperty(exports, "IDDocumentAuthenticationApi", {
  enumerable: true,
  get: function get() {
    return _IDDocumentAuthenticationApi["default"];
  }
});
Object.defineProperty(exports, "IDDocumentReaderResponse", {
  enumerable: true,
  get: function get() {
    return _IDDocumentReaderResponse["default"];
  }
});
Object.defineProperty(exports, "LivenessDetectionApi", {
  enumerable: true,
  get: function get() {
    return _LivenessDetectionApi["default"];
  }
});
Object.defineProperty(exports, "TasksCreateTaskResponse", {
  enumerable: true,
  get: function get() {
    return _TasksCreateTaskResponse["default"];
  }
});
Object.defineProperty(exports, "WebhooksApi", {
  enumerable: true,
  get: function get() {
    return _WebhooksApi["default"];
  }
});
Object.defineProperty(exports, "WebhooksDeleteEventURLResponse", {
  enumerable: true,
  get: function get() {
    return _WebhooksDeleteEventURLResponse["default"];
  }
});
Object.defineProperty(exports, "WebhooksGetEventURLResponse", {
  enumerable: true,
  get: function get() {
    return _WebhooksGetEventURLResponse["default"];
  }
});
Object.defineProperty(exports, "WebhooksSetEventURLResponse", {
  enumerable: true,
  get: function get() {
    return _WebhooksSetEventURLResponse["default"];
  }
});

var _ApiClient = _interopRequireDefault(require("./ApiClient"));

var _AuthCreateTokensResponse = _interopRequireDefault(require("./model/AuthCreateTokensResponse"));

var _AuthDeleteTokensResponse = _interopRequireDefault(require("./model/AuthDeleteTokensResponse"));

var _AuthGetTokensResponse = _interopRequireDefault(require("./model/AuthGetTokensResponse"));

var _DocumentVerificationResponse = _interopRequireDefault(require("./model/DocumentVerificationResponse"));

var _DocumentVerificationResult = _interopRequireDefault(require("./model/DocumentVerificationResult"));

var _EncodeErrorResponse = _interopRequireDefault(require("./model/EncodeErrorResponse"));

var _EntitiesDOFontAnalysis = _interopRequireDefault(require("./model/EntitiesDOFontAnalysis"));

var _EntitiesDoVerDocumentData = _interopRequireDefault(require("./model/EntitiesDoVerDocumentData"));

var _EntitiesDoVerKeywordsPred = _interopRequireDefault(require("./model/EntitiesDoVerKeywordsPred"));

var _EntitiesDoVerOCRPred = _interopRequireDefault(require("./model/EntitiesDoVerOCRPred"));

var _EntitiesDocumentCheckResult = _interopRequireDefault(require("./model/EntitiesDocumentCheckResult"));

var _EntitiesDocumentCheckTask = _interopRequireDefault(require("./model/EntitiesDocumentCheckTask"));

var _EntitiesFaceManipulationResult = _interopRequireDefault(require("./model/EntitiesFaceManipulationResult"));

var _EntitiesFaceManipulationTask = _interopRequireDefault(require("./model/EntitiesFaceManipulationTask"));

var _EntitiesFaceRecognitionResult = _interopRequireDefault(require("./model/EntitiesFaceRecognitionResult"));

var _EntitiesFaceRecognitionTask = _interopRequireDefault(require("./model/EntitiesFaceRecognitionTask"));

var _EntitiesGANResult = _interopRequireDefault(require("./model/EntitiesGANResult"));

var _EntitiesGANTask = _interopRequireDefault(require("./model/EntitiesGANTask"));

var _EntitiesIDDetectionResult = _interopRequireDefault(require("./model/EntitiesIDDetectionResult"));

var _EntitiesIDDetectionTask = _interopRequireDefault(require("./model/EntitiesIDDetectionTask"));

var _EntitiesIDDoAuthenticityCheck = _interopRequireDefault(require("./model/EntitiesIDDoAuthenticityCheck"));

var _EntitiesIDDoDocument = _interopRequireDefault(require("./model/EntitiesIDDoDocument"));

var _EntitiesIDDoDocumentDetails = _interopRequireDefault(require("./model/EntitiesIDDoDocumentDetails"));

var _EntitiesIDDoDocumentPosition = _interopRequireDefault(require("./model/EntitiesIDDoDocumentPosition"));

var _EntitiesIDDoFaceDetection = _interopRequireDefault(require("./model/EntitiesIDDoFaceDetection"));

var _EntitiesIDDoImageQualityCheck = _interopRequireDefault(require("./model/EntitiesIDDoImageQualityCheck"));

var _EntitiesIDDoReaderBBox = _interopRequireDefault(require("./model/EntitiesIDDoReaderBBox"));

var _EntitiesIDDoReaderImage = _interopRequireDefault(require("./model/EntitiesIDDoReaderImage"));

var _EntitiesIDDoReaderStatus = _interopRequireDefault(require("./model/EntitiesIDDoReaderStatus"));

var _EntitiesIDDoReaderStatusDetails = _interopRequireDefault(require("./model/EntitiesIDDoReaderStatusDetails"));

var _EntitiesIDDoReaderText = _interopRequireDefault(require("./model/EntitiesIDDoReaderText"));

var _EntitiesIDDoReaderTextExtracted = _interopRequireDefault(require("./model/EntitiesIDDoReaderTextExtracted"));

var _EntitiesLivenessDetectionResult = _interopRequireDefault(require("./model/EntitiesLivenessDetectionResult"));

var _EntitiesLivenessDetectionTask = _interopRequireDefault(require("./model/EntitiesLivenessDetectionTask"));

var _EntitiesPoint = _interopRequireDefault(require("./model/EntitiesPoint"));

var _EntitiesTokenClaims = _interopRequireDefault(require("./model/EntitiesTokenClaims"));

var _IDDocumentReaderResponse = _interopRequireDefault(require("./model/IDDocumentReaderResponse"));

var _TasksCreateTaskResponse = _interopRequireDefault(require("./model/TasksCreateTaskResponse"));

var _WebhooksDeleteEventURLResponse = _interopRequireDefault(require("./model/WebhooksDeleteEventURLResponse"));

var _WebhooksGetEventURLResponse = _interopRequireDefault(require("./model/WebhooksGetEventURLResponse"));

var _WebhooksSetEventURLResponse = _interopRequireDefault(require("./model/WebhooksSetEventURLResponse"));

var _AuthorizationApi = _interopRequireDefault(require("./api/AuthorizationApi"));

var _DataExtractionApi = _interopRequireDefault(require("./api/DataExtractionApi"));

var _FaceManipulationApi = _interopRequireDefault(require("./api/FaceManipulationApi"));

var _FaceMatchingApi = _interopRequireDefault(require("./api/FaceMatchingApi"));

var _ForensicAnalysisApi = _interopRequireDefault(require("./api/ForensicAnalysisApi"));

var _GANDetectionApi = _interopRequireDefault(require("./api/GANDetectionApi"));

var _IDDetectionApi = _interopRequireDefault(require("./api/IDDetectionApi"));

var _IDDocumentAuthenticationApi = _interopRequireDefault(require("./api/IDDocumentAuthenticationApi"));

var _LivenessDetectionApi = _interopRequireDefault(require("./api/LivenessDetectionApi"));

var _WebhooksApi = _interopRequireDefault(require("./api/WebhooksApi"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }